import { Fragment } from "react";
import { Info } from "@mui/icons-material";
import { Grid, IconButton, InputAdornment, Tooltip } from "@mui/material";

import { useAxios } from "../../../hooks";
import {
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { convertDate } from "../../../utils";
import { Autocomplete, ComponentHeader, TextField } from "../../../components";
import { useSelector } from "react-redux";

export function AddNewAgentForm({
  buttons,
  setButton,
  fields,
  setFields,
  handleClose,
  channels,
  formikProps,
}) {
  const { accessToken } = useSelector((state) => state.memberDetails);

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid size={12}>
          <ComponentHeader
            title={
              formikProps.values?.agent_id
                ? "Edit Delivery Channel Agent"
                : "Add Delivery Channel Agent"
            }
            subtitle={
              formikProps.values?.agent_id
                ? "Update agent assignments for each communication channel."
                : "Assign agent to manage communication across your active channels."
            }
            // buttons={[
            //   buttons && (
            //     <PrimaryButton
            //       variant="outlined"
            //       onClick={() => {
            //         window.open(buttons.url, "_blank");
            //       }}
            //     >
            //       Guidelines
            //     </PrimaryButton>
            //   ),
            // ]}
          />
        </Grid>

        <Grid size={12} />

        <Grid size={4}>
          <Autocomplete
            label={"Select Channel"}
            name="channel_id"
            placeholder="Select Channel"
            defaults={{
              primaryKey: "id",
              displayLabel: "channel_name",
            }}
            sx={{
              "& .MuiSvgIcon-root": {
                display: "none",
              },
            }}
            options={channels}
            onChange={(_, value, type) => handleChangeAudience(value, type)}
            formikProps={formikProps}
          />
        </Grid>
        {fields?.map((field, i) => (
          <Fragment>
            {field.name !== "expiry_token" && (
              <Grid size={4}>
                {/* {field.control_id === 1} */}

                <TextField
                  size="small"
                  formikProps={formikProps}
                  required={field.is_mandatory}
                  name={field.name}
                  label={field.label}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title={field.tooltip}>
                          <IconButton style={{ padding: 0 }}>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}

            {!!formikProps.values.agent_id && field.name === "expiry_token" && (
              <Grid size={4}>
                <TextField
                  size="small"
                  value={convertDate(formikProps.values.expiry_token)}
                  required={field.is_mandatory}
                  name={field.name}
                  label={field.label}
                  disabled
                />
              </Grid>
            )}
          </Fragment>
        ))}
        <Grid size={12} />
        <Grid size="auto" offset={{ xs: "auto" }} />

        <Grid size="auto">
          <PrimaryButton onClick={handleClose} variant="outlined">
            Cancel
          </PrimaryButton>
        </Grid>

        <Grid size="auto">
          <PrimaryLoadingButton
            type="submit"
            disabled={!formikProps.isValid}
            variant="contained"
            onClick={formikProps.handleSubmit}
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );

  function handleChangeAudience(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
        channelName: value.channel_name,
      }));

      axios({
        url: "/bot/get-agent-fields/" + value.id,
      }).then((response) => {
        if (response.status) {
          setFields(response?.data?.data);
          setButton(response.data?.pdf);
        }
      });
    } else {
      value = {
        id: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
      }));
    }
  }
}
